import React from 'react';
import { useDispatch } from 'react-redux';
import objectAssign from 'object-assign';
import { updateBeforeCallsForm } from '../../../../actions/waitingArea.js';
import { Checkbox, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting.js';

export default function CenterPanel(props) {
  const dispatch = useDispatch();

  const beforeCallsFormUpdated = (property, value) => {
    let updatedBeforeCallsForm = objectAssign({}, props.beforeCallsForm, { [property]: value });
    return updatedBeforeCallsForm;
  };

  const ifProvideFirstName = () => {
    dispatch(
      updateBeforeCallsForm(beforeCallsFormUpdated('isFirstNameMandatory', !props.beforeCallsForm.isFirstNameMandatory))
    );
  };

  const ifProvideLastName = () => {
    dispatch(
      updateBeforeCallsForm(beforeCallsFormUpdated('isLastNameMandatory', !props.beforeCallsForm.isLastNameMandatory))
    );
  };

  const ifProvideDOB = (value) => {
    dispatch(updateBeforeCallsForm(beforeCallsFormUpdated('isDobMandatory', !props.beforeCallsForm.isDobMandatory)));
  };

  const ifProvidePhoneNumber = (value) => {
    dispatch(
      updateBeforeCallsForm(
        beforeCallsFormUpdated('isPhoneNumberMandatory', !props.beforeCallsForm.isPhoneNumberMandatory)
      )
    );
  };

  return (
    <span>
      <div className="ui form">
        <label className="div-like mrbs">{APP.LANGUAGE.WaitingAreaBeforeCallsCallers.Title}</label>
        <Container fluid as={Media} greaterThanOrEqual="computer">
          <Checkbox
            tabIndex="1"
            className="div-like mrbs"
            label={APP.LANGUAGE.WaitingAreaBeforeCallsCallers.FirstNameCheckboxText}
            disabled={props.updateOrView == 'view' ? true : false}
            checked={props.beforeCallsForm.isFirstNameMandatory}
            onChange={ifProvideFirstName}
          />
          <Checkbox
            tabIndex="2"
            className="div-like mrbs"
            label={APP.LANGUAGE.WaitingAreaBeforeCallsCallers.LastNameCheckboxText}
            disabled={props.updateOrView == 'view' ? true : false}
            checked={props.beforeCallsForm.isLastNameMandatory}
            onChange={ifProvideLastName}
          />
          {props.waitingArea.showDobField == true ? (
            <Checkbox
              tabIndex="3"
              className="div-like mrbs"
              label={APP.LANGUAGE.WaitingAreaBeforeCallsCallers.DOBCheckboxText}
              disabled={props.updateOrView == 'view' ? true : false}
              checked={props.beforeCallsForm.isDobMandatory}
              onChange={ifProvideDOB}
            />
          ) : (
            ''
          )}
          <Checkbox
            tabIndex="3"
            className="div-like mrbs"
            label={APP.LANGUAGE.WaitingAreaBeforeCallsCallers.PhoneNemberCheckboxText}
            disabled={props.updateOrView == 'view' ? true : false}
            checked={props.beforeCallsForm.isPhoneNumberMandatory}
            onChange={ifProvidePhoneNumber}
          />
        </Container>
        <Container fluid as={Media} lessThan="computer">
          <Checkbox
            tabIndex="1"
            className="div-like mrbm"
            label={APP.LANGUAGE.WaitingAreaBeforeCallsCallers.FirstNameCheckboxText}
            disabled={props.updateOrView == 'view' ? true : false}
            checked={props.beforeCallsForm.isFirstNameMandatory}
            onChange={ifProvideFirstName}
          />
          <Checkbox
            tabIndex="2"
            className="div-like mrbm"
            label={APP.LANGUAGE.WaitingAreaBeforeCallsCallers.LastNameCheckboxText}
            disabled={props.updateOrView == 'view' ? true : false}
            checked={props.beforeCallsForm.isLastNameMandatory}
            onChange={ifProvideLastName}
          />
          {props.waitingArea.showDobField == true ? (
            <Checkbox
              tabIndex="3"
              className="div-like mrbs"
              label={APP.LANGUAGE.WaitingAreaBeforeCallsCallers.DOBCheckboxText}
              disabled={props.updateOrView == 'view' ? true : false}
              checked={props.beforeCallsForm.isDobMandatory}
              onChange={ifProvideDOB}
            />
          ) : (
            ''
          )}
          <Checkbox
            tabIndex="3"
            className="div-like mrbm"
            label={APP.LANGUAGE.WaitingAreaBeforeCallsCallers.PhoneNemberCheckboxText}
            disabled={props.updateOrView == 'view' ? true : false}
            checked={props.beforeCallsForm.isPhoneNumberMandatory}
            onChange={ifProvidePhoneNumber}
          />
        </Container>
      </div>
    </span>
  );
}
